import { STORE_UI_PREFERENCES } from '@Actions/uiPreferencesAction';
export function uiPreferencesReducer(state = { uiPreferences: window.UI_PREFERENCES }, action) {
    switch (action.type) {
        case STORE_UI_PREFERENCES:
            return Object.assign(Object.assign({}, state), { uiPreferences: action.uiPreferences });
        default:
            return state;
    }
}
